import localeMixin from "./localeMixin";

export default {
  mixins: [localeMixin],

  computed: {
    motorId() {
      return this.$store.state.build.motor;
    },
    //
    // tank() {
    //   let state = this.$store.state;
    //   return state.tanks.all;
    // },
    //
    // pump() {
    //   let state = this.$store.state;
    //   return state.pumps.all;
    // },
    //
    // valves() {
    //   let state = this.$store.state;
    //   return state.build.valves.all;
    // },

    // circuit() {
    //   return this.$store.state.build.circuit;
    // },

    getDeliveryTime() {
      let delivery = [];

      let motor = this.$store.state.motors.byId[this.motorId];
      if (motor && motor.stock < 1) {
        delivery.push({days: motor.delivery_days})
      }

      let circuit = this.$store.getters["build/getCircuit"];
      if (circuit && circuit.stock < 1) {
        delivery.push({days: circuit.delivery_days})
      }

      let tank = this.$store.getters["build/getTank"];
      if (tank && tank.stock < 1) {
        delivery.push({days: tank.delivery_days})
      }

      let pump = this.$store.getters["build/getPump"];
      if (pump && pump.stock < 1) {
        delivery.push({days: pump.delivery_days})
      }

      let buildValves = this.$store.getters["build/valves/getValves"];
      const valveIds = [];
      const additionalValveIds = [];
      buildValves.forEach(valve => {
        valveIds.push(valve.id);
        valve.additionalValves.forEach(additionalValveId => {
          additionalValveIds.push(additionalValveId);
        })
      });

      let allValves = Object.values(this.$store.getters["valves/getAll"]);

      allValves.map(v => {
        if(valveIds.includes(v.id)) {
          delivery.push({days: v.delivery_days});
        }
      }).filter(valves => valves !== undefined);


      let allAdditionalValves = Object.values(this.$store.getters["additionalValves/getAll"]);

      allAdditionalValves.map(v => {
        if(additionalValveIds.includes(v.id)) {
          delivery.push({days: v.delivery_days});
        }
      }).filter(valves => valves !== undefined);

      const maxDays = Math.max(...delivery.map(o => o.days), 0);

      if(maxDays > 0) {
        return maxDays + 3;
      }
    }
  },
}
